import './viewingBadge.css';

/** Read-only status: this is the version currently displayed, not necessarily the latest. */
export function ViewingBadge({ className = '' }: { className?: string }) {
  return <span className={`oq-viewing-badge oq-text-micro ${className}`}>Viewing</span>;
}
